/**
 * 10/07/2026 — fix user prod « Romuald disponible en pleine mission ».
 *
 * Réconciliation quotidienne : tout chauffeur référencé par un contrat
 * actif (contract.driverId) doit être `active` avec le bon véhicule —
 * sauf s'il est en congés / maladie / formation (l'intérim couvre alors
 * la mission). Corrige les dérives de statut accumulées dans les parties
 * existantes, quelle que soit la voie d'affectation d'origine.
 */
const PROTECTED_STATUSES = new Set(['holiday', 'vacation', 'sick', 'training', 'resting', 'striking', 'on_break', 'notice']);

export function reconcileDriverContractStatus(drivers, activeContracts) {
  const busy = new Map();
  (activeContracts || []).forEach(c => {
    if (c && c.driverId && c.status !== 'completed' && c.status !== 'cancelled') {
      busy.set(c.driverId, c.vehicleId || null);
    }
  });
  if (busy.size === 0) return drivers;
  let changed = false;
  const out = (drivers || []).map(d => {
    if (!busy.has(d.id)) return d;
    if (d.onHoliday || PROTECTED_STATUSES.has(d.status)) return d;
    const vehicleId = busy.get(d.id);
    if (d.status === 'active' && (!vehicleId || d.assignedVehicleId === vehicleId)) return d;
    changed = true;
    return { ...d, status: 'active', assignedVehicleId: vehicleId || d.assignedVehicleId || null };
  });
  return changed ? out : drivers;
}
